import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';

const useStore = <K extends keyof StoreInterface>(key: REDUX_STORE_SLICES): StoreInterface[K] => {
  return useSelector((store: StoreInterface) => store[key]) as StoreInterface[K];
};

export default useStore;
